import { facetOptionSlug } from 'client-portal/utils/clinicianSearch/facet-option-slug';

export const SELF_PAY_INSURANCE_VALUE = 'Self-Pay';

function normalizeInsuranceName(value) {
  return String(value ?? '').trim();
}

function isSelfPayName(value) {
  return normalizeInsuranceName(value).toLowerCase() === SELF_PAY_INSURANCE_VALUE.toLowerCase();
}

export function insuranceCountByLowerFromBuckets(buckets = []) {
  let countByLower = new Map();

  for (let bucket of buckets) {
    let key = normalizeInsuranceName(bucket?.key);
    if (!key) {
      continue;
    }

    let lower = key.toLowerCase();
    let nextCount = (countByLower.get(lower) ?? 0) + Number(bucket.count ?? 0);
    countByLower.set(lower, nextCount);
  }

  return countByLower;
}

export function catalogHasSelfPay(records = []) {
  return (records ?? []).some(record => !!record?.acceptSelfPayCashIndicator);
}

function marketingInsuranceProvidersFromRecords(records = []) {
  return (records ?? []).flatMap(record => record?.marketingInsuranceProviders ?? []);
}

function addProviderName(labelByLower, raw) {
  let name = normalizeInsuranceName(raw);
  if (!name || isSelfPayName(name)) {
    return;
  }

  let lower = name.toLowerCase();
  if (!labelByLower.has(lower)) {
    labelByLower.set(lower, name);
  }
}

export function insuranceProviderNamesFromRecords(records = []) {
  let labelByLower = new Map();

  for (let raw of marketingInsuranceProvidersFromRecords(records)) {
    addProviderName(labelByLower, raw);
  }

  return [...labelByLower.values()].sort((a, b) => a.localeCompare(b));
}

export function insuranceNamesFromRecords(records = []) {
  let providers = insuranceProviderNamesFromRecords(records);
  if (catalogHasSelfPay(records)) {
    return [SELF_PAY_INSURANCE_VALUE, ...providers];
  }
  return providers;
}

export function buildInsuranceFacetOptions(records = [], buckets = []) {
  let countByLower = insuranceCountByLowerFromBuckets(buckets);

  return insuranceNamesFromRecords(records).map(name => ({
    key: name,
    slug: facetOptionSlug(name),
    label: name,
    isSelfPay: isSelfPayName(name),
    docCount: countByLower.get(name.toLowerCase()) ?? 0,
  }));
}

export function isSelfPayInsuranceFilter(value) {
  return isSelfPayName(value);
}
